import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { push as pushAction } from 'redux-first-history';

import Frap from 'shared/app/components/frap-with-messages/';
import runSequentially from 'shared/app/utils/run-sequentially';
import FrapContainer from 'shared/app/components/frap-container';
import { isMobileViewportSelector } from 'shared/app/bundles/viewport';
import { useSessionCheckContext } from 'shared/app/shell/lib/session-check-provider';

import { setScanToPayCardId as setScanToPayCardIdAction } from '../../state/actions/cards-management';

import { svcMessages } from 'shared/app/messages';
import sharedMessages from '../shared-messages';

const CardFraps = ({
  card: { cardId },
  isMobileViewport,
  push,
  setScanToPayCardId,
}) => {
  const openPayOverlay = () =>
    runSequentially(
      () => setScanToPayCardId(cardId),
      () => push('#pay')
    );

  const { checkReAuthRequired } = useSessionCheckContext();

  // use imported pushAction, not connected version, as checkReAuthRequired will do the dispatch
  const addMoneyCallback = () => {
    checkReAuthRequired({
      nextAction: () => pushAction('#add-money'),
    });
  };

  const scanButton = (
    <Frap
      data-e2e="scanButton"
      onClick={() => {
        openPayOverlay();
      }}
    >
      <FormattedMessage {...svcMessages.scanInStore} />
    </Frap>
  );

  return (
    <FrapContainer>
      <Frap
        data-e2e="addMoneyButton"
        mini={isMobileViewport}
        onClick={() => {
          addMoneyCallback();
        }}
      >
        <FormattedMessage {...sharedMessages.addMoney} />
      </Frap>
      {isMobileViewport && scanButton}
    </FrapContainer>
  );
};

const select = (state) => ({
  isMobileViewport: isMobileViewportSelector(state),
});

const actions = {
  push: pushAction,
  setScanToPayCardId: setScanToPayCardIdAction,
};

export default connect(select, actions)(CardFraps);
